import api from './axios';

// Get all active popups (public)
export const getAllPopups = async () => {
  const response = await api.get('/popups');
  return response.data;
};

// Get all popups (admin - includes inactive and expired)
export const getAllPopupsAdmin = async (params = {}) => {
  const response = await api.get('/popups/admin/all', { params });
  return response.data;
};

// Get single popup
export const getPopupById = async (id) => {
  const response = await api.get(`/popups/${id}`);
  return response.data;
};

// Create popup
export const createPopup = async (formData) => {
  const response = await api.post('/popups', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update popup
export const updatePopup = async (id, data) => {
  const response = await api.patch(`/popups/${id}`, data, {
    headers: {
      'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json',
    },
  });
  return response.data;
};

// Toggle popup status
export const togglePopupStatus = async (id) => {
  const response = await api.patch(`/popups/${id}/toggle`);
  return response.data;
};

// Delete popup
export const deletePopup = async (id) => {
  const response = await api.delete(`/popups/${id}`);
  return response.data;
};

// Bulk delete popups
export const bulkDeletePopups = async (ids) => {
  const response = await api.delete('/popups/bulk/delete', {
    data: { ids },
  });
  return response.data;
};

export default {
  getAllPopups,
  getAllPopupsAdmin,
  getPopupById,
  createPopup,
  updatePopup,
  togglePopupStatus,
  deletePopup,
  bulkDeletePopups,
};
